/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ERP API
 * 날짜·요일·시간 요청 및 응답은 UTC 기준입니다. 시간대 없는 date/time/date-time 값도 UTC로 해석하며 서버에서 KST로 변환하지 않습니다. 프런트에서 시간대를 변환할 때 날짜와 요일도 함께 변환해야 합니다. 날짜 검색의 from/to는 UTC 시작 포함·종료 미포함입니다. time_zone을 지원하는 조회의 날짜 그룹은 해당 시간대를 따릅니다. 생일 등 날짜 자체를 의미하는 값은 입력한 날짜를 그대로 사용합니다.
 * OpenAPI spec version: v1
 */
import type {
  AcademyStudentBulkCreateParams,
  AcademyStudentDisconnectTestgateParams,
  AcademyStudentDownloadBulkTemplateParams,
  AcademyStudentGetAllStudentsParams,
  AcademyStudentGetAttendanceSummaryParams,
  AcademyStudentGetConsultationHistoriesParams,
  AcademyStudentGetEnrolledStudentsParams,
  AcademyStudentGetInquiryHistoriesParams,
  AcademyStudentGetLessonHistoriesParams,
  AcademyStudentGetProspectStudentsParams,
  AcademyStudentGetSearchStatusCountsParams,
  AcademyStudentGetStatusCountsParams,
  AcademyStudentGetStudentDetailParams,
  AcademyStudentGetWithdrawnStudentsParams,
  AcademyStudentValidateBulkCreateParams,
  AcademyStudentValidateBulkLoginIdsParams,
  BaseResponsePageResponseEnrolledStudentListItemResponse,
  BaseResponsePageResponseProspectStudentListItemResponse,
  BaseResponsePageResponseStudentAllListItemResponse,
  BaseResponsePageResponseStudentConsultationHistoryItemResponse,
  BaseResponsePageResponseStudentInquiryHistoryItemResponse,
  BaseResponsePageResponseStudentLessonHistoryItemResponse,
  BaseResponsePageResponseWithdrawnStudentListItemResponse,
  BaseResponseStudentAttendanceDetailResponse,
  BaseResponseStudentAttendanceHistoryResponse,
  BaseResponseStudentAttendanceSummaryResponse,
  BaseResponseStudentBulkLoginIdValidateResponse,
  BaseResponseStudentBulkValidateResponse,
  BaseResponseStudentClassesResponse,
  BaseResponseStudentCreateResponse,
  BaseResponseStudentDetailResponse,
  BaseResponseStudentHomeResponse,
  BaseResponseStudentNoteCreateResponse,
  BaseResponseStudentOnlineJoinResponse,
  BaseResponseStudentOnlineMeetingsResponse,
  BaseResponseStudentProfileResponse,
  BaseResponseStudentScheduleResponse,
  BaseResponseStudentSearchStatusCountsResponse,
  BaseResponseStudentStatusCountsResponse,
  BaseResponseStudentTestgateLinkResponse,
  BaseResponseVoid,
  JoinParams,
  StudentBulkLoginIdValidateRequest,
  StudentBulkValidateRequest,
  StudentCreateRequest,
  StudentDeleteRequest,
  StudentGetAttendanceDetailParams,
  StudentGetAttendanceHistoryParams,
  StudentGetClassesParams,
  StudentGetHomeParams,
  StudentGetScheduleParams,
  StudentLinkedParentUpdateRequest,
  StudentNoteCreateRequest,
  StudentParentAccountCreateRequest,
  StudentProfileUpdateRequest,
  StudentTestgateLinkRequest,
  StudentTestgateUpdateRequest,
  StudentUpdateRequest,
} from '.././models';

import { customInstance } from '../../../../shared/apiClient/orvalMutator';

export const getStudent = () => {
  /**
 * 로그인한 학생 본인만 조회합니다. 요청 파라미터는 없습니다.
student_information: 학생 이름/학년/학교명/전화/이메일, parent_information: 학생에 등록된 학부모 연락처입니다.
school_options는 소속 학원의 선택 가능한 학교 ID/학원 ID/학교명 목록이며 학교명/ID 순입니다. 삭제된 학교/학원은 제외합니다.
student_information.school_id는 현재 학교 ID, linked_parents는 연결된 학부모 계정의 ID/이름/연락처 목록입니다.
학부모 계정 수정 화면은 linked_parents를 사용합니다. parent_information은 학생에 별도로 기록된 연락처입니다.
account.login_id는 LOGIN_ID 인증 계정의 ID이며 없으면 null, password_set은 비밀번호 설정 여부입니다. 비밀번호/해시는 반환하지 않습니다.
account_connections는 TESTGATE만 반환합니다. 연결되지 않았으면 connected=false, email/linked_at=null입니다.
연결 여부는 저장된 계정 연결 기준이며 외부 서비스나 OAuth 토큰의 실시간 유효성을 검증하지 않습니다. linked_at은 UTC ISO-8601입니다.
academies는 삭제되지 않은 학원-학생 연결의 학원 목록이며 퇴원 이력도 포함합니다. 삭제된 학원은 제외하고 학원 ID 순으로 반환합니다.
미등록 정보는 null, 소속 학원이 없으면 빈 배열입니다. 기존 /api/user/me 응답에는 영향이 없습니다.

 * @summary 학생 My Page 내 정보 조회
 */
  const studentGetProfile = () => {
    return customInstance<BaseResponseStudentProfileResponse>({ url: `/api/students/me`, method: 'GET' });
  };
  /**
 * 로그인한 학생 본인의 이름/학년/학교/전화/이메일을 전체 교체합니다. 이름과 학년은 필수입니다.
school_id는 본인의 소속 학원에 등록된 학교만 허용합니다. school_id/phone/email 누락 또는 null은 삭제입니다.
전화는 숫자만 저장합니다. 로그인 ID/비밀번호/외부 연결 계정은 변경하지 않습니다.

 * @summary 학생 본인 정보 수정
 */
  const studentUpdateProfile = (studentProfileUpdateRequest: StudentProfileUpdateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/students/me`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: studentProfileUpdateRequest,
    });
  };
  /**
 * 로그인한 학생과 연결된 parent_id의 학부모 계정 전화/이메일을 전체 교체합니다.
parent_id는 GET /api/students/me의 linked_parents[].parent_id를 사용합니다.
누락/null/빈 문자열은 해당 연락처 삭제이며 전화는 숫자만 저장합니다.
학부모 실제 계정의 공통 연락처를 변경하므로 같은 학부모를 연결한 다른 자녀의 linked_parents에도 반영됩니다.
요청 학생의 parent_information 연락처도 함께 변경하지만 다른 학생의 별도 기록은 변경하지 않습니다.
연결되지 않았거나 삭제된 학부모는 수정할 수 없습니다. 계정을 생성하거나 연결하지 않습니다.
로그인 ID/비밀번호/외부 연결 계정은 변경하지 않습니다.

 * @summary 학생의 연결 학부모 연락처 수정
 */
  const studentUpdateLinkedParent = (parentId: number, studentLinkedParentUpdateRequest: StudentLinkedParentUpdateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/students/me/parents/${parentId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: studentLinkedParentUpdateRequest,
    });
  };
  /**
   * 학생 user ID, 기본 정보와 TestGate 이메일, 실제 Zoom ID, 관리자 기록용 Zoom ID를 조회합니다.
   * @summary 학생 상세 조회
   */
  const academyStudentGetStudentDetail = (studentId: number, params: AcademyStudentGetStudentDetailParams) => {
    return customInstance<BaseResponseStudentDetailResponse>({ url: `/api/academy/students/${studentId}`, method: 'GET', params });
  };
  /**
   * @summary 학생 수정
   */
  const academyStudentUpdate = (studentId: number, studentUpdateRequest: StudentUpdateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/academy/students/${studentId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: studentUpdateRequest,
    });
  };
  /**
   * ERP 사용자 ID와 TestGate 이메일을 받아 TestGate 사용자를 조회한 뒤 숫자형 사용자 ID와 이메일을 연결하거나 교체합니다.
   * @summary 학생 TestGate 사용자 수정
   */
  const academyStudentUpdateTestgate = (studentTestgateUpdateRequest: StudentTestgateUpdateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/academy/students/testgate`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: studentTestgateUpdateRequest,
    });
  };
  /**
   * 학원 사용자가 접근 가능한 학생의 ERP 사용자 ID(userId)를 받아 TestGate 연동을 해제합니다. 이미 연동이 없어도 성공합니다.
   * @summary 학생 TestGate 연동 해제
   */
  const academyStudentDisconnectTestgate = (params: AcademyStudentDisconnectTestgateParams) => {
    return customInstance<BaseResponseVoid>({ url: `/api/academy/students/testgate`, method: 'DELETE', params });
  };
  /**
 * 학생 본인의 온라인 수업 참가 링크를 반환합니다. 요청 body는 없습니다. 외부 수업 링크는 Zoom 연동/라이선스 조회 없이 LINK_CLICK으로 처리합니다.
활성 학원·수강의 회차 시작 30분 전부터 종료까지(경계 포함)만 URL을 반환합니다. 이미 출석한 학생도 재입장할 수 있습니다.
ZOOM_JOIN은 학생별 링크로 실제 입장 시 출석하며, LINK_CLICK은 호출 시 출석합니다. 최초 출석·지각 반영 시 해당 자동 알림 설정(enabled 및 STUDENT/PARENT)에 따라 개인 온라인 등원 알림을 생성합니다. 재입장·링크 재호출·상태 변경 없는 이벤트에는 중복 발송하지 않습니다.
Zoom 계정 연동은 필요 없으며 ZOOM_JOIN에는 학생 이름과 이메일이 필요합니다.
후보 조회는 GET /api/students/schedule/{lessonSessionStudentId}/online-meetings를 사용합니다. 회의가 여러 개면 선택한 ERP 회의 ID를 양수 query zoom_meeting_id로 전달합니다. 여러 후보에서 ID 생략 또는 후보 밖 선택은 ONLINE_JOIN_UNAVAILABLE입니다. 한 개면 자동 선택합니다. 응답의 join_url을 열어 참가합니다. 중복 출석과 기존 출결 덮어쓰기를 방지합니다.
상세 조건: docs/zoom-student-attendance.md.

 * @summary 학생 온라인 수업 바로가기
 */
  const join = (lessonSessionStudentId: number, params?: JoinParams) => {
    return customInstance<BaseResponseStudentOnlineJoinResponse>({
      url: `/api/students/schedule/${lessonSessionStudentId}/online-join`,
      method: 'POST',
      params,
    });
  };
  /**
 * ERP 학생 로그인과 TestGate 학생 access token이 모두 필요합니다. 학부모는 사용할 수 없습니다.
TestGate에서 토큰과 활성 학생을 확인한 뒤 본인 계정에 연결합니다.
같은 계정 재요청은 성공하며, 다른 계정으로 교체하려면 DELETE /api/students/me/external-accounts/testgate로 먼저 연결을 해제해야 합니다.
TestGate 토큰은 저장하지 않습니다.

 * @summary 학생 본인 TestGate 계정 연결
 */
  const studentLinkTestgate = (studentTestgateLinkRequest: StudentTestgateLinkRequest) => {
    return customInstance<BaseResponseStudentTestgateLinkResponse>({
      url: `/api/students/me/external-accounts/testgate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: studentTestgateLinkRequest,
    });
  };
  /**
 * ERP에 로그인한 학생 본인의 TestGate 연결만 해제합니다. 요청 본문과 TestGate 토큰은 필요하지 않습니다.
외부 계정 연결을 soft delete하고 provider_user_id를 삭제용 고유 값으로 변경합니다.
이미 연결되지 않은 상태도 성공합니다. 같은 계정 또는 다른 TestGate 계정으로 다시 연결할 수 있습니다.
TestGate 서비스의 계정 삭제나 토큰 폐기는 수행하지 않습니다. Zoom 연결에는 영향이 없습니다.

 * @summary 학생 본인 TestGate 계정 연결 해제
 */
  const studentDisconnectTestgate = () => {
    return customInstance<BaseResponseVoid>({ url: `/api/students/me/external-accounts/testgate`, method: 'DELETE' });
  };
  /**
   * 입학상담생, 재원생, 퇴원생을 상태 구분 없이 전체 조회합니다.
   * @summary 학생 전체 목록 조회
   */
  const academyStudentGetAllStudents = (params: AcademyStudentGetAllStudentsParams) => {
    return customInstance<BaseResponsePageResponseStudentAllListItemResponse>({ url: `/api/academy/students`, method: 'GET', params });
  };
  /**
   * @summary 학생 생성
   */
  const academyStudentCreate = (studentCreateRequest: StudentCreateRequest) => {
    return customInstance<BaseResponseStudentCreateResponse>({
      url: `/api/academy/students`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: studentCreateRequest,
    });
  };
  /**
   * student_ids 목록의 학생, 학원 소속, 사용자 계정 및 인증/외부 계정 연결을 soft delete합니다. 중복 ID는 한 번만 처리하며, 없는 학생 또는 권한 없는 학생이 포함되면 전체 요청을 취소합니다. 학생이 속한 모든 학원의 접근 권한이 필요합니다. 학부모 계정과 수강/출결/상담 이력은 보존합니다. 로그인 ID와 소셜 인증 ID는 191자 이내의 고유 삭제 값으로 변경하여 재사용할 수 있게 합니다.
   * @summary 학생 일괄 삭제
   */
  const academyStudentDelete = (studentDeleteRequest: StudentDeleteRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/academy/students`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      data: studentDeleteRequest,
    });
  };
  /**
   * 학원 소속 학생에 학부모 계정을 생성하거나 기존 학부모 계정을 연결합니다. parent_login_id는 필수이며 parent_email 생략 또는 공백 시 학생의 기존 학부모 이메일을 사용합니다. 로그인 ID 또는 이메일에 해당하는 학부모가 있으면 해당 계정을 재사용하며, 이메일로 기존 계정을 찾으면 요청한 로그인 ID를 새로 만들지 않습니다. 이미 학부모가 연결된 학생은 변경 없이 성공합니다. 신규 계정의 초기 비밀번호는 12345678*입니다.
   * @summary 학생의 학부모 로그인 계정 생성 및 연결
   */
  const academyStudentParentAccountCreate = (studentId: number, studentParentAccountCreateRequest: StudentParentAccountCreateRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/academy/students/${studentId}/parent-account`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: studentParentAccountCreateRequest,
    });
  };
  /**
   * @summary 학생 특이사항 생성
   */
  const academyStudentCreateNote = (studentId: number, studentNoteCreateRequest: StudentNoteCreateRequest) => {
    return customInstance<BaseResponseStudentNoteCreateResponse>({
      url: `/api/academy/students/${studentId}/notes`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: studentNoteCreateRequest,
    });
  };
  /**
   * 사전 검증과 같은 요청 바디를 받아 전체 검증 후 실패가 없을 때만 학생을 일괄 등록합니다.
   * @summary 학생 벌크 등록
   */
  const academyStudentBulkCreate = (studentBulkValidateRequest: StudentBulkValidateRequest, params: AcademyStudentBulkCreateParams) => {
    return customInstance<BaseResponseStudentBulkValidateResponse>({
      url: `/api/academy/students/bulk`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: studentBulkValidateRequest,
      params,
    });
  };
  /**
   * 학생 벌크 등록 전에 저장 없이 전체 데이터를 검증하고, 실패 항목은 loginId와 사유로 반환합니다.
   * @summary 학생 벌크 등록 사전 검증
   */
  const academyStudentValidateBulkCreate = (studentBulkValidateRequest: StudentBulkValidateRequest, params: AcademyStudentValidateBulkCreateParams) => {
    return customInstance<BaseResponseStudentBulkValidateResponse>({
      url: `/api/academy/students/bulk/validate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: studentBulkValidateRequest,
      params,
    });
  };
  /**
   * 학생 벌크 등록 중 로그인ID만 빠르게 검증합니다. DB 중복과 요청 내부 중복만 확인합니다.
   * @summary 학생 벌크 로그인ID 중복 검증
   */
  const academyStudentValidateBulkLoginIds = (
    studentBulkLoginIdValidateRequest: StudentBulkLoginIdValidateRequest,
    params: AcademyStudentValidateBulkLoginIdsParams
  ) => {
    return customInstance<BaseResponseStudentBulkLoginIdValidateResponse>({
      url: `/api/academy/students/bulk/validate/login-id`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: studentBulkLoginIdValidateRequest,
      params,
    });
  };
  /**
 * from/to는 선택일 수업의 UTC 시작 시각 범위(시작 포함·종료 미포함, 최대 24시간)이며 date 필터보다 우선합니다. month는 달력 조회에 계속 필요합니다. time_zone은 달력/날짜 그룹 기준(기본 UTC, 한국 날짜는 Asia/Seoul)이며 회차 시각은 UTC로 유지됩니다. from/to 누락 쌍·역전·범위 초과·잘못된 time_zone은 BAD_REQUEST입니다.
월별 달력과 선택일 수업·교시·출석 버튼 정보를 반환합니다. month(yyyy-MM)는 필수입니다.
학생 본인 또는 학부모의 연결 자녀만 조회합니다. 달력은 인접 월의 표시 주간도 포함합니다.
date 생략 시 이번 달은 UTC 오늘, 다른 달은 1일을 선택하며 달력 범위 안이어야 합니다.
QR 출석 버튼은 활성 수강의 회차 시작 30분 전부터 종료까지 이용합니다. QR 토큰은 별도 발급합니다.
온라인 링크는 회차 연결 Zoom > 수업 공용 Zoom > 기존 외부 링크 순으로 선택합니다.
online_class는 enabled/status/zoom_meeting_id만 반환합니다. details.attendance.lesson_session_student_id로 바로가기 API를 호출합니다.
학생 JWT로 POST /api/students/schedule/{lesson_session_student_id}/online-join 호출 후 응답의 실제 링크를 엽니다.
온라인 버튼은 출석 가능 시간에만 활성화하며 학부모는 비활성입니다.
입장 조건이 충족된 다중 회의는 enabled=true, status=MEETING_SELECTION_REQUIRED이며 online-meetings 후보 조회 API 호출 후 회의를 선택합니다. 조회만으로 등록·출석 처리되지 않습니다. 상세 조건: docs/zoom-student-attendance.md.

 * @summary 학생 My Class 월별 일정
 */
  const studentGetSchedule = (params: StudentGetScheduleParams) => {
    return customInstance<BaseResponseStudentScheduleResponse>({ url: `/api/students/schedule`, method: 'GET', params });
  };
  /**
   * 학생 본인·활성 학원/수강·온라인 회차 및 입장 가능 시간(시작 30분 전~종료)을 검증합니다. 회차 직접 연결 회의를 우선하며 없으면 수업 공용 회의를 반환합니다. 목록은 ERP 회의 ID/제목/UTC 시작 시각/길이만 제공하며 URL 발급·Zoom 호출·출석 처리는 하지 않습니다. 외부 링크만 사용하면 meetings는 빈 목록이고 기존 바로가기 POST를 호출합니다. 양수 위반 VALIDATION_ERROR, 형식 오류 BAD_REQUEST, 권한 없음 FORBIDDEN, 조건 미충족 ONLINE_JOIN_UNAVAILABLE, 학생 없음 STUDENT_NOT_FOUND.
   * @summary 학생 회차의 온라인 회의 후보 조회
   */
  const meetings = (lessonSessionStudentId: number) => {
    return customInstance<BaseResponseStudentOnlineMeetingsResponse>({
      url: `/api/students/schedule/${lessonSessionStudentId}/online-meetings`,
      method: 'GET',
    });
  };
  /**
 * 학생 본인 또는 학부모의 연결 자녀를 조회합니다.
활성 수강의 남은 등록 회차를 수업별로 가장 빠른 1개씩 반환합니다. 진행 중 회차도 포함합니다.
classes의 lesson_session_student_id, online_enabled, online_status로 온라인 버튼을 표시합니다. URL은 반환하지 않습니다.
학생 JWT로 POST /api/students/schedule/{lesson_session_student_id}/online-join 호출 후 응답의 실제 join_url을 엽니다.
학부모는 온라인 버튼 비활성입니다. 입장 조건이 충족된 다중 회의는 enabled=true, status=MEETING_SELECTION_REQUIRED이며 online-meetings 후보 조회 API 호출 후 회의를 선택합니다. 조회만으로 출석 처리되지 않습니다.
상세 조건: docs/zoom-student-attendance.md.

 * @summary 학생 홈 조회
 */
  const studentGetHome = (params?: StudentGetHomeParams) => {
    return customInstance<BaseResponseStudentHomeResponse>({ url: `/api/students/home`, method: 'GET', params });
  };
  /**
 * Classes 탭용. 학생 본인 또는 student_id로 지정한 학부모의 연결 자녀를 조회합니다.
PENDING/ACTIVE/COMPLETED 수강을 반환하며 DROPPED/CANCELED/REFUNDED와 삭제된 학원/수업/수강은 제외합니다.
PENDING/ACTIVE(Current)를 먼저, COMPLETED(Completed)를 뒤에 반환합니다.
각 그룹에서 수업 시작일 내림차순, 수업 ID/수강 ID 내림차순입니다.
네 회차 집계 값은 모두 session_type=LESSON만 대상으로 합니다. total_session_count는 실제 생성된 LESSON 회차 중 취소/삭제 제외 수이며, completed_session_count는 그중 DONE 수입니다.
enrolled_session_count는 본인의 REGISTERED 회차 중 취소/삭제 제외 수이며 completed_enrolled_session_count는 그중 DONE 수입니다.
HOLD는 분모에 포함됩니다. 완료는 회차 상태 기준이며 출석 여부나 조회 시각으로 판정하지 않습니다.
회차가 없으면 0/0, 시험 유형이 없으면 exam_types=[], 수강이 없으면 classes=[]입니다.
Classroom 화면 이동에는 lesson_id를 사용합니다. Schedule 탭 데이터는 포함하지 않습니다.

 * @summary 학생 My Class 수업 목록
 */
  const studentGetClasses = (params?: StudentGetClassesParams) => {
    return customInstance<BaseResponseStudentClassesResponse>({ url: `/api/students/classes`, method: 'GET', params });
  };
  /**
 * 학생은 본인, 학부모는 student_id로 지정한 연결 자녀가 수강한 수업 하나의 전체 날짜를 조회합니다. 학생은 student_id 생략 또는 본인 ID 지정, 학부모는 필수입니다. 기간 제한은 없습니다.
dates는 수업 날짜 최신순, 날짜 안의 sessions는 시작시간/회차 ID/등록 ID 오름차순입니다.
각 sessions.events에는 저장된 CHECK_IN/CHECK_OUT/STATUS_CHANGED 이벤트를 모두 반환합니다.
이벤트는 occurred_at 내림차순, 같은 시각이면 이벤트 ID 내림차순입니다. 재입장/퇴장/정정 기록을 생략하지 않습니다.
최종 attendance_status가 null이거나 회차/회차등록이 이후 취소/환불/HOLD되어도 이벤트가 있으면 표시합니다.
이벤트도 최종 출결도 없는 예정 회차는 표시하지 않습니다. 최종 출결만 남은 과거 데이터는 events=[]로 반환합니다.
lesson_student_id는 수강 등록 식별자, registration_status와 session_status는 현재 등록/회차 상태입니다.
attendance_status는 현재 상태 참고값이며 변경 이력은 events의 before/after를 사용합니다.
삭제된 학생/학원학생/수강/수업/학원/회차/회차등록은 기존 soft delete 정책대로 제외합니다.
날짜 미지정 이력은 date=null인 마지막 카드, 시간 미지정 값은 null입니다.
total_session_count는 취소/삭제 제외 전체 수업 회차 수, enrolled_session_count는 그중 본인의 REGISTERED 행 수입니다.
이 두 수는 예정/HOLD/미처리 회차도 포함하며 날짜 카드 및 출석률의 분모와 다릅니다.
attendance_rate=(present+late)/(present+late+absent)*100, 소수 둘째 자리 반올림, 분모 0이면 0.00입니다.
조퇴/VOD는 별도 집계하며 출석률 계산에서 제외합니다. summary는 현재 유효 REGISTERED 회차 중 시작한 출결 처리 회차의 최종 상태 집계입니다.
취소/HOLD/날짜·시간 미지정 회차는 summary에서 제외하며, 반복 이벤트를 출석 횟수로 중복 계산하지 않습니다.
session_number는 날짜/시작시간이 있는 전체 LESSON 회차의 날짜/시작시간/ID 순번(1부터)입니다.
취소/삭제 회차는 순번에서 제외하며 미등록/미처리 회차도 순번에는 포함합니다. 다른 유형은 null입니다.
check_in_at은 카드에 표시되는 회차의 CHECK_IN 이벤트 중 최초 시각(UTC, Z)이며 없으면 null입니다.
session_methods는 카드의 출결 방식(ONLINE/OFFLINE/VOD) 중복 제거 배열이며 null 방식은 제외합니다.
수업 시간은 UTC, 카드 시간은 표시 회차의 MIN(start_time)/MAX(end_time)입니다.
대표 강사명은 현재 값이며 미지정/삭제 시 null입니다. 수강은 있으나 이벤트/출결이 없으면 dates=[], summary는 0입니다.
없는 수업과 본인 수강이 없는 수업은 동일하게 LESSON_NOT_FOUND를 반환합니다.

 * @summary 학생/자녀의 수업 전체 출석 상세
 */
  const studentGetAttendanceDetail = (lessonId: number, params?: StudentGetAttendanceDetailParams) => {
    return customInstance<BaseResponseStudentAttendanceDetailResponse>({ url: `/api/students/attendance/lessons/${lessonId}`, method: 'GET', params });
  };
  /**
 * from/to는 UTC 시작 시각 범위(시작 포함·종료 미포함, 최대 366일)이며 from_date/to_date보다 우선합니다. time_zone은 날짜 그룹 기준(기본 UTC, 한국 날짜는 Asia/Seoul)이며 수업 시각은 UTC로 유지됩니다. 누락 쌍·역전·범위 초과·잘못된 time_zone은 BAD_REQUEST입니다.
학생은 본인, 학부모는 student_id로 지정한 연결 자녀를 조회합니다. 학생은 student_id 생략 또는 본인 ID 지정, 학부모는 필수입니다.
dates는 날짜 내림차순, 날짜 안의 classes는 가장 이른 시작 시각/수업 ID 오름차순입니다.
학생 본인 + 날짜 + 수업 기준으로 등록 회차의 최종 출결 상태를 집계합니다.
present=ATTEND, late=LATE, absent=ABSENT, leave_early=LEAVE_EARLY, vod=VOD이며 null은 집계하지 않습니다.
이력 이벤트 수 또는 전체 학생 수가 아닙니다. 미처리 회차는 목록/드롭다운에서 제외하며 출결이 있는 회차만 표시합니다.
시간은 집계 대상 회차의 MIN(start_time)/MAX(end_time)이며 UTC입니다.
현재 시각까지 시작한 회차만 포함하고 CANCELED/HOLD 회차, 취소/환불된 회차 등록,
삭제된 학생/학원/학원학생/수업/수강/회차/회차등록 및 날짜/시간 미지정 회차는 제외합니다.
수강 자체의 현재 상태로 과거 이력을 제외하지 않으므로 종료/퇴원 수강의 유효 회차도 포함합니다.
class_options는 같은 기간의 이력 있는 수업 전체이며 lesson_id 필터로 축소되지 않습니다.
대표 강사명은 현재 값이며 미지정/삭제 시 null입니다. All Classes 항목은 프론트에서 추가합니다.
to_date 생략 시 UTC 오늘, from_date 생략 시 to_date의 29일 전입니다. 양 끝 날짜 포함, 최대 366일입니다.
없는 수업 또는 본인 이력 없는 수업을 필터링하면 dates=[]입니다. 전체 이력이 없으면 두 목록 모두 []입니다.
상세 이동은 GET /api/students/attendance/lessons/{lesson_id}이며 수업 전체 날짜를 조회합니다. 이 API는 상세 내역을 포함하지 않습니다.

 * @summary 학생/자녀 출석 History 조회
 */
  const studentGetAttendanceHistory = (params?: StudentGetAttendanceHistoryParams) => {
    return customInstance<BaseResponseStudentAttendanceHistoryResponse>({ url: `/api/students/attendance/history`, method: 'GET', params });
  };
  /**
   * @summary 퇴원생 목록 조회
   */
  const academyStudentGetWithdrawnStudents = (params: AcademyStudentGetWithdrawnStudentsParams) => {
    return customInstance<BaseResponsePageResponseWithdrawnStudentListItemResponse>({ url: `/api/academy/students/withdrawn`, method: 'GET', params });
  };
  /**
   * @summary 학생 상태별 인원 조회
   */
  const academyStudentGetStatusCounts = (params: AcademyStudentGetStatusCountsParams) => {
    return customInstance<BaseResponseStudentStatusCountsResponse>({ url: `/api/academy/students/status-counts`, method: 'GET', params });
  };
  /**
   * 재원생/퇴원생/입학 상담생 목록과 동일한 검색 조건으로 각 탭의 건수를 함께 조회합니다.
   * @summary 검색 조건별 학생 상태 수 조회
   */
  const academyStudentGetSearchStatusCounts = (params: AcademyStudentGetSearchStatusCountsParams) => {
    return customInstance<BaseResponseStudentSearchStatusCountsResponse>({ url: `/api/academy/students/search-status-counts`, method: 'GET', params });
  };
  /**
   * @summary 입학 상담생 목록 조회
   */
  const academyStudentGetProspectStudents = (params: AcademyStudentGetProspectStudentsParams) => {
    return customInstance<BaseResponsePageResponseProspectStudentListItemResponse>({ url: `/api/academy/students/prospect`, method: 'GET', params });
  };
  /**
   * 학생 상세 화면에서 academyStudentId 기준 과목 대분류를 포함한 수강 내역을 조회합니다. historyGroup=ENROLLED는 PENDING/ACTIVE/COMPLETED, CANCELED_REFUNDED는 CANCELED/REFUNDED이며 생략 시 전체입니다. status는 수강 상태, ended_at은 종료일입니다. id는 수강 등록 ID이며, lesson_id는 수강 상세 이동에 사용하는 수업 ID입니다. registered_session_count는 LESSON 타입 등록 회차 수이며, remaining_session_count는 그중 attendance_status가 없는 회차 수입니다.
   * @summary 학생 수강 내역 조회
   */
  const academyStudentGetLessonHistories = (params: AcademyStudentGetLessonHistoriesParams) => {
    return customInstance<BaseResponsePageResponseStudentLessonHistoryItemResponse>({ url: `/api/academy/students/lesson-history`, method: 'GET', params });
  };
  /**
   * academy_id만 전달하면 학원 전체 문의, academy_student_id를 전달하면 학생 문의를 조회합니다. 둘 중 하나는 필수이며 모두 전달하면 학원 소속이 일치해야 합니다. 학생 미등록 상담도 전체 목록에 포함하며 academy_student_id는 null일 수 있습니다. 학생 정보와 상담에 연결된 수업을 문의일(상담일) 최신순으로 반환합니다. 학교·학년, 학생·학부모 이메일, 학부모 전화번호, 카카오 메모는 상담에 저장된 값을 반환하며 managers는 상담에 지정된 담당자의 학원 사용자 ID, 사용자 ID, 이름과 역할을 반환하며 미지정 시 빈 목록입니다. lesson_id는 선택 검색 조건이며 전달하면 해당 수업의 문의만 조회합니다. 양수만 허용합니다. 동일 수업을 재문의하면 각각 반환하며 total_elements는 상담-수업 연결 건수입니다. enrollment_status는 해당 학생의 현재 PENDING/ACTIVE/COMPLETED 수강이 있으면 REGISTERED, 나머지는 NOT_REGISTERED입니다. 상담 조회와 동일한 권한을 적용하며 page는 1부터, 기본 size는 20입니다.
   * @summary 학원/학생 문의 수업 목록 조회
   */
  const academyStudentGetInquiryHistories = (params?: AcademyStudentGetInquiryHistoriesParams) => {
    return customInstance<BaseResponsePageResponseStudentInquiryHistoryItemResponse>({ url: `/api/academy/students/inquiry-history`, method: 'GET', params });
  };
  /**
   * @summary 재원생 목록 조회
   */
  const academyStudentGetEnrolledStudents = (params: AcademyStudentGetEnrolledStudentsParams) => {
    return customInstance<BaseResponsePageResponseEnrolledStudentListItemResponse>({ url: `/api/academy/students/enrolled`, method: 'GET', params });
  };
  /**
   * 학생 상세 화면에서 academyStudentId 기준 상담 내역을 조회합니다. enrollment_status와 consultation_type은 상담에 기록된 값이며 created_at은 기록 시각입니다.
   * @summary 학생 상담 내역 조회
   */
  const academyStudentGetConsultationHistories = (params: AcademyStudentGetConsultationHistoriesParams) => {
    return customInstance<BaseResponsePageResponseStudentConsultationHistoryItemResponse>({
      url: `/api/academy/students/consultation-history`,
      method: 'GET',
      params,
    });
  };
  /**
   * 기존 엑셀 템플릿의 학교목록 시트에 학교명을 채워 xlsx 파일로 다운로드합니다.
   * @summary 학생 벌크 등록 엑셀 템플릿 다운로드
   */
  const academyStudentDownloadBulkTemplate = (params: AcademyStudentDownloadBulkTemplateParams) => {
    return customInstance<Blob>({ url: `/api/academy/students/bulk-template/download`, method: 'GET', params, responseType: 'blob' });
  };
  /**
   * academy_student_id 기준으로 attendance_status가 있는 출결 데이터의 출석/지각/결석 횟수와 출석률((출석 + 지각) / 전체 출결)을 조회합니다.
   * @summary 학생 출결 내역 요약 조회
   */
  const academyStudentGetAttendanceSummary = (params: AcademyStudentGetAttendanceSummaryParams) => {
    return customInstance<BaseResponseStudentAttendanceSummaryResponse>({ url: `/api/academy/students/attendance-summary`, method: 'GET', params });
  };
  /**
   * @summary 학생 특이사항 삭제
   */
  const academyStudentDeleteNote = (studentNoteId: number) => {
    return customInstance<BaseResponseVoid>({ url: `/api/academy/students/notes/${studentNoteId}`, method: 'DELETE' });
  };
  return {
    studentGetProfile,
    studentUpdateProfile,
    studentUpdateLinkedParent,
    academyStudentGetStudentDetail,
    academyStudentUpdate,
    academyStudentUpdateTestgate,
    academyStudentDisconnectTestgate,
    join,
    studentLinkTestgate,
    studentDisconnectTestgate,
    academyStudentGetAllStudents,
    academyStudentCreate,
    academyStudentDelete,
    academyStudentParentAccountCreate,
    academyStudentCreateNote,
    academyStudentBulkCreate,
    academyStudentValidateBulkCreate,
    academyStudentValidateBulkLoginIds,
    studentGetSchedule,
    meetings,
    studentGetHome,
    studentGetClasses,
    studentGetAttendanceDetail,
    studentGetAttendanceHistory,
    academyStudentGetWithdrawnStudents,
    academyStudentGetStatusCounts,
    academyStudentGetSearchStatusCounts,
    academyStudentGetProspectStudents,
    academyStudentGetLessonHistories,
    academyStudentGetInquiryHistories,
    academyStudentGetEnrolledStudents,
    academyStudentGetConsultationHistories,
    academyStudentDownloadBulkTemplate,
    academyStudentGetAttendanceSummary,
    academyStudentDeleteNote,
  };
};
export type StudentGetProfileResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['studentGetProfile']>>>;
export type StudentUpdateProfileResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['studentUpdateProfile']>>>;
export type StudentUpdateLinkedParentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['studentUpdateLinkedParent']>>>;
export type AcademyStudentGetStudentDetailResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentGetStudentDetail']>>>;
export type AcademyStudentUpdateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentUpdate']>>>;
export type AcademyStudentUpdateTestgateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentUpdateTestgate']>>>;
export type AcademyStudentDisconnectTestgateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentDisconnectTestgate']>>>;
export type JoinResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['join']>>>;
export type StudentLinkTestgateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['studentLinkTestgate']>>>;
export type StudentDisconnectTestgateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['studentDisconnectTestgate']>>>;
export type AcademyStudentGetAllStudentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentGetAllStudents']>>>;
export type AcademyStudentCreateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentCreate']>>>;
export type AcademyStudentDeleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentDelete']>>>;
export type AcademyStudentParentAccountCreateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentParentAccountCreate']>>>;
export type AcademyStudentCreateNoteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentCreateNote']>>>;
export type AcademyStudentBulkCreateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentBulkCreate']>>>;
export type AcademyStudentValidateBulkCreateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentValidateBulkCreate']>>>;
export type AcademyStudentValidateBulkLoginIdsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentValidateBulkLoginIds']>>>;
export type StudentGetScheduleResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['studentGetSchedule']>>>;
export type MeetingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['meetings']>>>;
export type StudentGetHomeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['studentGetHome']>>>;
export type StudentGetClassesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['studentGetClasses']>>>;
export type StudentGetAttendanceDetailResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['studentGetAttendanceDetail']>>>;
export type StudentGetAttendanceHistoryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['studentGetAttendanceHistory']>>>;
export type AcademyStudentGetWithdrawnStudentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentGetWithdrawnStudents']>>>;
export type AcademyStudentGetStatusCountsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentGetStatusCounts']>>>;
export type AcademyStudentGetSearchStatusCountsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentGetSearchStatusCounts']>>>;
export type AcademyStudentGetProspectStudentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentGetProspectStudents']>>>;
export type AcademyStudentGetLessonHistoriesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentGetLessonHistories']>>>;
export type AcademyStudentGetInquiryHistoriesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentGetInquiryHistories']>>>;
export type AcademyStudentGetEnrolledStudentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentGetEnrolledStudents']>>>;
export type AcademyStudentGetConsultationHistoriesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentGetConsultationHistories']>>
>;
export type AcademyStudentDownloadBulkTemplateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentDownloadBulkTemplate']>>>;
export type AcademyStudentGetAttendanceSummaryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentGetAttendanceSummary']>>>;
export type AcademyStudentDeleteNoteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStudent>['academyStudentDeleteNote']>>>;
